import React from 'react'
import {MDBSpinner} from "mdbreact";

const CustomLoader = ({paddingTop}) => (
	<div className="w-100 text-center" style={{paddingTop: paddingTop}}>
		<MDBSpinner red big/>
	</div>
)

export default CustomLoader